import React, { useRef, useState } from 'react';
import { Upload, X, Loader2, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';
import { uploadFile, fileUrl } from '../utils/api';

export const FileUploadField = ({ label, value, onChange, publicToken = null, required = false, accept = 'image/*,application/pdf', hint }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 20 * 1024 * 1024) { toast.error('File too large (max 20 MB)'); return; }
    setUploading(true);
    try {
      const res = await uploadFile(file, publicToken);
      onChange(res.absoluteUrl, res.filename);
    } catch (err) {
      toast.error('Upload failed: ' + err.message);
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const testid = `upload-${(label || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;

  return (
    <div className="border border-slate-200 rounded-lg p-3 bg-white">
      <label className="text-sm font-medium text-slate-700 block mb-1">
        {label}{required && <span className="text-red-500"> *</span>}
      </label>
      {hint && <p className="text-xs text-slate-500 mb-2">{hint}</p>}
      {value ? (
        <div className="flex items-center gap-2">
          <CheckCircle className="text-green-600 flex-shrink-0" size={18} />
          <a href={fileUrl(value, publicToken)} target="_blank" rel="noopener noreferrer" className="text-sm text-blue-600 underline truncate flex-1">View uploaded file</a>
          <button type="button" onClick={() => onChange('', '')} className="text-red-500 flex-shrink-0" data-testid={`${testid}-remove`}><X size={16} /></button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="flex items-center gap-2 text-sm px-3 py-2 border border-dashed border-slate-300 rounded-lg hover:bg-slate-50 w-full justify-center text-slate-600 disabled:opacity-60"
          data-testid={testid}
        >
          {uploading ? <><Loader2 className="animate-spin" size={16} /> Uploading…</> : <><Upload size={16} /> Upload file</>}
        </button>
      )}
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handleSelect} />
    </div>
  );
};

export default FileUploadField;
